import { useSelector } from "react-redux";
import { VERSION } from "../ducks/consts";

export default function ShopFooter() {
  const informationFooter = useSelector(
    (state) => state.shop.informationFooter,
  );

  return (
    <footer className="shop-footer">
      {informationFooter && (
        <div
          className="shop-footer__custom"
          dangerouslySetInnerHTML={{ __html: informationFooter }}
        />
      )}
      <p className="shop-footer__credits">
        {"Cardápio digital por "}
        <a
          href="https://sistemapallas.com.br"
          target="_blank"
          rel="noopener noreferrer"
        >
          Sistema Pallas
        </a>
        {/* a versão fica aqui, discreta, para o suporte pedir ao cliente */}
        <span className="shop-footer__version">{VERSION}</span>
      </p>
    </footer>
  );
}
